import Sdata from '@/database/sdata'

let g_entity = 'caisse_cloture'
let g_url    = 'studio/cloture'
let g_pkey   = ['uid','terminal']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Cloture extends Sdata
{
  static entity = g_entity
  static url    = g_url
  static pkey   = g_pkey
}